import React, { useState, useEffect, useContext } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

import { Dialog, DialogContent, DialogTitle, Button, DialogActions, CircularProgress, TextField, FormControl, FormControlLabel, Switch, InputLabel, Select, MenuItem } from "@material-ui/core";

import { Autocomplete } from "@material-ui/lab";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
  root: { display: "flex", flexWrap: "wrap", },

  multFieldLine: {
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const ContactLinkModal = ({ open, onClose, contact, contactLink, modules }) => {
  const classes = useStyles();

  const initialState = {
    contactId: "",
    description: ""
  };
  const [subscription, setSubscription] = useState(initialState);
  const [contacts, setContacts] = useState([]);
  const [plans, setPlans] = useState([]);
  const [selectedContact, setSelectedContact] = useState({id: "", name: "", number: ""});
  
  


  const SessionSchema = Yup.object().shape({
    contactId: Yup.string().when((schema) => {
      if (!selectedContact)
        return Yup.string().required((i18n.t("validation.required")));
    }),
  });


  const changeDate = async (e) => {
    const valueString = new Date(e.expiresAt);
    const newValue = moment(valueString).format('YYYY-MM-DDTHH:mm');
    setSelectedContact(e.contact);
    setSubscription({ ...e, 'expiresAt': newValue });

  };

  useEffect(() => {

    const delayDebounceFn = setTimeout(() => {

      if (contactLink) {

        {
          contactLink?.contactId === contact?.id
          ?
          setSelectedContact({id: contactLink?.contactLinkId, name: contactLink?.contactLinkIdName, number: contactLink?.contactLinkIdNumber})
          :
          setSelectedContact({id: contactLink?.contactId, name: contactLink?.contactIdName, number: contactLink?.contactIdNumber})
        }
        // if (contactLink?.contactId  === contact?.id){
        // {link?.contactId === contact?.id ? link?.contactLinkIdNumber : link?.contactIdNumber}
        //   setSelectedContact({name: contactLink.contactIdName, number: contactLink.contactIdNumber});
      }

      const fetchContacts = async () => {
        try {
          const { data } = await api.get("contacts/list");
          setContacts(data);

        } catch (err) {
          toastError(err);
        }
      };
      // eslint-disable-next-line
      { open === true && fetchContacts(); }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [open, contactLink, contact]);


  useEffect(() => {
    const fetchSession = async () => {
      if (!contactLink) return;
      
      try {
        setSubscription(contactLink)
        // const { data } = await api.get(`subscription/${contactLink}`);
        // eslint-disable-next-line
        // changeDate(data);

      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
    // eslint-disable-next-liue
  }, [contactLink]);

  const handleSave = async (values) => {
    try {



      if (contactLink) {
        const subscriptionData = { 
          linkId: selectedContact.id,
          isContactId: contactLink?.contactId === contact?.id ? true : false,
          description: values.description
       }
        await api.put(`/contactLinks/${contactLink.id}`, subscriptionData);
      } else {

        const subscriptionData = { 
          contactId: contact.id,
          contactLinkId: selectedContact.id,
          description: values.description
       }
        await api.post("/contactLinks", subscriptionData);
      }
      toast.success(i18n.t("global.successSave"));
      handleClose();

    } catch (err) {
      toastError(err);
    }

  };

  const handleSetSelectedContact = (newValue) => {
    setSelectedContact(newValue)
  }
  const handleClose = () => {
    onClose();
    setSubscription(initialState);
    setSelectedContact(null);
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          {contactLink
            ? `${i18n.t("global.buttons.edit")} ${i18n.t("contactLink.name")}`
            : `${i18n.t("global.buttons.add")} ${i18n.t("contactLink.name")}`
          }
        </DialogTitle>
        <Formik
          initialValues={subscription}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSave(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (

            <Form>
              {/* selectedContact: {selectedContact} */}
              <DialogContent dividers>
                <FormControl variant="outlined" fullWidth margin="dense">
                  <Autocomplete
                    autoHighlight
                    name="contactId"
                    id="contactId"
                    value={selectedContact}
                    defaultValue={selectedContact}
                    options={contacts}
                    // isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={({ name, number }) => {
                      return name ? `${name} (${number})` : "";
                    }}
                    renderOption={(option) => <span>{`${option.name} (${option.number})`} </span>}
                    renderInput={(params) =>
                      <Field
                        type="text"
                        as={TextField}
                        autoFocus
                        variant="outlined"
                        name="contactId"
                        {...params}
                        label={i18n.t("global.subscription")}
                        placeholder={i18n.t("global.subscription")}
                        error={touched.contactId && Boolean(errors.contactId)}
                        helpertext={touched.contactId && errors.contactId}
                      />
                    }
                    onChange={(e, newValue) => handleSetSelectedContact(newValue)}
                  />
                </FormControl>

                <div>
                  <FormControl variant="outlined" margin="dense" fullWidth>
                    <Field
                      as={TextField}
                      label={i18n.t("global.description")}
                      multiline
                      minRows={5}
                      name="description"
                      variant="outlined"
                      margin="dense"
                    />
                  </FormControl>
                </div>

              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("global.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  className={classes.btnWrapper}
                >
                  {contactLink
                    ? i18n.t("global.buttons.okEdit")
                    : i18n.t("global.buttons.okAdd")}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default React.memo(ContactLinkModal);
